var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"point-store__two-column-list relative grid grid-cols-2 gap-4"},_vm._l((_vm.list),function(item,index){return _c('list-item',{key:'child' + index,attrs:{"item":item,"model":_vm.model},on:{"exchange-success":function($event){return _vm.$emit('exchange-success')}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }